import { Component, Input } from '@angular/core';
import { Company, CompanyEnum } from '../../models/company.model';
import { ApplicationFormComponent } from '../application-form/application-form.component';
import { PriceListsPopupComponent } from '../price-lists-popup/price-lists-popup.component';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';
import { PublicHolidaysComponent } from '../public-holidays/public-holidays.component';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-price-list-links',
  templateUrl: './price-list-links.component.html',
  styleUrls: ['./price-list-links.component.scss', './print-price-list-links.component.scss'],
  imports: [ApplicationFormComponent, PriceListsPopupComponent, TermsAndConditionsComponent, PublicHolidaysComponent, NgIf],
})
export class PriceListLinksComponent {
  @Input() publicHolidays = true;
  @Input() company: Company = CompanyEnum.KIL;
  @Input() countryCode: string | undefined;
  @Input() applicationForms = [];
}
